import { restrictToVerticalAxis } from '@dnd-kit/modifiers';

/**
 * Shared dnd-kit modifiers for vertical reorder surfaces. Constrains the dragged
 * row to the vertical axis so full-width list items don't drift horizontally.
 * Apply to every vertical `DndContext` via `modifiers={reorderModifiers}`.
 */
export const reorderModifiers = [restrictToVerticalAxis];
